<script setup lang="ts">
import { useNotificacaoStore } from "@/shared/store/notificacao_store";

const store = useNotificacaoStore();
</script>

<template>
  <div v-if="store.isOpen" class="overlay">
    <div class="card-notificacao">
      <h2 class="titulo" :class="{ erro: !store.isSuccess }">
        {{ store.titulo }}
      </h2>

      <p class="mensagem">{{ store.mensagem }}</p>
      <div class="btn-wrapper">
        <button class="btn-fechar" @click="store.close">Fechar</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.card-notificacao {
  font-family: "Qubic Grid", sans-serif;
  width: 680px;
  height: 219px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  color: #002233;
}

.titulo {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
}

.mensagem {
  font-size: 16px;
  margin-bottom: 28px;
}

.btn-fechar {
  width: 222px;
  height: 56px;
  margin: 0 auto;
  border: none;
  border-radius: 16px;
  font-size: 24px;
  cursor: pointer;
  color: #002233;
  background-color: #f7a41c;
  padding: 12px 10px;
  font-weight: 700;
}

.btn-fechar:hover {
  opacity: 0.9;
}
.btn-wrapper {
  text-align: center;
}
</style>
